<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>众筹转电商</span>
    </div>
    <div class="cont top">
        <div class="title">什么情况下可以众筹转电商？</div>
        <ul class="circle">
            <li>未通过摩点选品，不满足全网首发的众筹，不会通过审核，可以转为电商商品售卖；</li>
            <li>众筹结束之后，可以转为电商商品，承接众筹后期余量；</li>
        </ul>
    </div>
    <div class="cont">
        <div class="title">摩点商城入驻会收取哪些费用？</div>
        <ul class="circle">
            <li>
                <strong style="padding: 0;">个人店铺</strong>
                <p>1000 元店铺保证金，常规商品交易扣点 10%；</p>
            </li>
            <li>
                <strong>企业店铺</strong>
                <p>10000 元店铺保证金，常规商品交易扣点 10%；</p>
            </li>
        </ul>
    </div>
    <div class="cont">
        <div class="title">如何申请？</div>
        <p>摩点商城商户自主入驻操作说明</p>
        <ul class="no">
            <li>
                <strong>登陆入口</strong>
            </li>
            <p>打开摩点商城商户入驻入口链接：<a href="https://center.modian.com/shop_entry" target="_blank">https://center.modian.com/shop_entry</a></p>
            <p>点击<strong style="display: inline-block;padding:0;">“立即入驻”</strong>按钮；</p>
            <el-image 
                class="enlarged pc-image"
                :src="shop1"
                :preview-src-list="imageList"
                :initial-index="0"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <li>
                <strong>账号认证</strong>
            </li>
            <p>如商户未在摩点进行（企业或个人）账号认证，需根据提示进行账号认证，点击“去认证”按钮；</p>
            <el-image 
                class="enlarged pc-image"
                :src="shop2"
                :preview-src-list="imageList"
                :initial-index="1"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p>商户根据自身身份入驻情况，选择对应的身份进行账号认证，如个人商户入驻选择“个人认证”，如企业商户入驻选择“企业认证”；</p>
            <el-image 
                style="margin: 40px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop3"
                :preview-src-list="imageList"
                :initial-index="2"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <ul class="circle" style="margin: 40px 0 0 -20px;">
                <li><strong>个人账号认证操作页面</strong></li>
            </ul>
            <p>根据提示填写个人认证相关信息，上传本人手持身份证照片（要求身份证上的信息须清晰展示），提交后等待审核。个人账号认证信息填写页面截图如下：</p>
            <el-image 
             style="margin: 80px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop4"
                :preview-src-list="imageList"
                :initial-index="3"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <ul class="circle" style="margin: 40px 0 0 -20px;">
                <li><strong>企业账号认证操作页面</strong></li>
            </ul>
            <p>企业账号认证商户操作页面，须填写企业名称、社会信用代码、法定代表人信息，上传营业执照，提交信息后等待审核。企业账号认证信息填写页面截图如下：</p>
            <el-image 
                style="margin: 80px 0 40px 20px;"
                class="enlarged pc-image"
                :src="shop5"
                :preview-src-list="imageList"
                :initial-index="4"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <li>
                <strong>账号认证审核</strong>
                <p>提交账号认证信息后，摩点工作人员将在3~5个工作日内处理审核。</p>
            </li>
            <el-image 
                style="margin: 40px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop6"
                :preview-src-list="imageList"
                :initial-index="5"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <li><strong>入驻商城信息填写</strong></li>
            <ul class="circle" style="margin: 0 0 0 -20px;">
                <li><strong>填写店铺信息</strong></li>
            </ul>
            <p>账号认证通过审核后，登陆到<a href="https://center.modian.com/shop_entry" target="_blank">https://center.modian.com/shop_entry</a></p>
            <p>点击“立即入驻”按钮，跳转到填写入驻资料页面，根据提示填写店铺名称、店铺介绍、邀请码（SC5QTT），上传店铺logo图（尺寸大小300*300）及店铺主页背景图（尺寸大小1125*600），点击“下一步”，进入品牌信息填写页面。</p>
            <el-image 
                style="margin: 60px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop7"
                :preview-src-list="imageList"
                :initial-index="6"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <ul class="circle" style="margin: 40px 0 0 -20px;">
                <li><strong>填写品牌信息</strong></li>
            </ul>
            <p>选择经营品牌，如在筛选项下未找到经营品牌，可选择“点击新增”，添加需要新增的品牌，选择品牌类型、经营类型、商标资质有效期（参考商标注册证或授权销售书上有效期），上传授权销售书及或商标注册证，提交审核。</p>
            <el-image 
                style="margin: 40px 0 40px 20px;"
                class="enlarged pc-image"
                :src="shop8"
                :preview-src-list="imageList"
                :initial-index="7"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p>新增品牌操作按钮：</p>
            <el-image 
                style="margin: 40px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop9"
                :preview-src-list="imageList"
                :initial-index="8"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <ul class="circle" style="margin: 40px 0 0 -20px;">
                <li><strong>选择经营类目</strong></li>
            </ul>
            <p>根据自身情况选择需要经营的类目，根据类目给出的提示上传对应资质文件，上传相关资质文件后，点击“下一步”操作，进入到阅读《摩点商城商家入驻协议》按钮。</p>
            <el-image 
                style="margin: 40px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop10"
                :preview-src-list="imageList"
                :initial-index="9"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <el-image 
                style="margin: 60px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop11"
                :preview-src-list="imageList"
                :initial-index="10"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <ul class="circle" style="margin: 40px 0 0 -20px;">
                <li><strong>签署商城入驻协议</strong></li>
            </ul>
            <p>仔细阅读《摩点商城商家入驻协议》内容，若同意协议内容，勾选“我已仔细阅读并同意《摩点商城商家入驻协议》”，点击“下一步”操作，等待审核结果。</p>
            <el-image 
                style="margin: 40px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop12"
                :preview-src-list="imageList"
                :initial-index="11"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <ul class="circle" style="margin: 40px 0 0 -20px;">
                <li><strong>等待审核结果</strong></li>
            </ul>
            <p>入驻资料提交后，摩点工作人员将在3~7个工作内审核，审核结果请关注APP消息。</p>
            <el-image 
                style="margin: 40px 0 0 20px;"
                class="enlarged pc-image"
                :src="shop13"
                :preview-src-list="imageList"
                :initial-index="12"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <ul class="circle" style="margin: 40px 0 0 -20px;">
                <li><strong>缴纳保证金</strong></li>
            </ul>
            <p>入驻资料通过审核后，商户根据系统给出的汇款账号信息，线下缴纳保证金。</p>
            <p>注：商户缴纳保证金主体名称须与摩点完成认证的经营主体名称一致。</p>
            <el-image 
                style="margin: 40px 0 60px 20px;"
                class="enlarged pc-image"
                :src="shop14"
                :preview-src-list="imageList"
                :initial-index="13"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
        </ul>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const shop1 = `${CDN_BASE}shop_1.png`
const shop2 = `${CDN_BASE}shop_2.png`
const shop3 = `${CDN_BASE}shop_3.png`
const shop4 = `${CDN_BASE}shop_4.png`
const shop5 = `${CDN_BASE}shop_5.png`
const shop6 = `${CDN_BASE}shop_6.png`
const shop7 = `${CDN_BASE}shop_7.png`
const shop8 = `${CDN_BASE}shop_8.png`
const shop9 = `${CDN_BASE}shop_9.png`
const shop10 = `${CDN_BASE}shop_10.png`
const shop11 = `${CDN_BASE}shop_11.png`
const shop12 = `${CDN_BASE}shop_12.png`
const shop13 = `${CDN_BASE}shop_13.png`
const shop14 = `${CDN_BASE}shop_14.png`

// 图片列表，用于预览
const imageList = [shop1, shop2, shop3, shop4, shop5, shop6, shop7, shop8, shop9, shop10, shop11, shop12, shop13, shop14]

const router = useRouter()
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}

</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    a{
        color: #425EB2;
    }
    p{
        font-size: 14px;
        line-height: 1;
    }
    .el-image {
        height: auto;
        cursor: pointer;
        
        &.enlarged {
            transform: scale(1.2);
            transform-origin: center;
            transition: transform 0.3s ease;
        }
        
        &.pc-image {
            width: 667px;
            margin:20px 0 0 20px;
        }
        
        &.app-image {
            width: 159px;
            margin:20px 0 0 0;
        }
    }
    ul{
        padding: 0 0 0 20px;
        line-height: 21px;
        p{
            line-height: 1.5;
            margin: 0 0 0 -20px;
            padding: 15px 0 0 0;
        }
        li{
            font-size: 14px;
            line-height: 21px;
            strong{
                line-height: 1;
                display: block;
                padding: 20px 0 0 0;
                font-weight: 600;
            }
        }
        &.no{
            list-style-type: decimal;
            li{
                list-style: decimal;
            }
        }
        
        &.circle{
            list-style-type: disc;
            li{
                list-style: disc;
            }
        }
    }
}
</style>